function toDisplayLine(line: any) {
  // normalized
  if (line?.title || line?.unit_price || line?.image) {
    return {
      title: line.title ?? "Item",
      qty: Number(line.quantity ?? 1),
      price: Number(line.unit_price ?? 0),
      image: line.image ?? null,
      vendorName: line.vendor_name ?? null,
    };
  }
  // raw from cart snapshot
  const p = line?.product ?? {};
  return {
    title: p.title ?? "Item",
    qty: Number(line?.quantity ?? 1),
    price: Number(p.price ?? 0),
    image: Array.isArray(p.images) && p.images.length ? p.images[0] : null,
    vendorName: p.vendor?.store_name ?? null,
  };
}

function currency(v?: number) {
  const n = typeof v === "number" && !Number.isNaN(v) ? v : 0;
  return `$${n.toFixed(2)}`;
}

export { toDisplayLine, currency };